<template>
  <div class="book">
      <h2>Book id: {{ $route.params.id }}</h2>

      <h4> Title: {{ book.Title}} </h4>
    </div>
</template>
<script>

      import * as API from './../../api';

    //const CreateModal = () => import('./CreateDialog');     <CreateModal @create-modal-visibility="changeModalVisibility()"  v-if="createVegetableDialog" :create-vegetable-dialog="createVegetableDialog"></CreateModal>

    export default {
        name: "Books",
        methods: {
            getBook() {
               this.$api.get(API.endpoints.books + '/' + this.$route.params.id)
                    .then(response => {
                        this.book = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            title: "Error",
                            message: error,
                            type: 'danger'
                        });
                    });
            },
        },
        data() {
            return {
                book: [ ],
               
            }
        },
        mounted() {
            this.getBook();
        },

    }
</script>